import styled from "styled-components";

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 20px;
  max-width: 100%;
  align-items: center;

  @media (max-width: 1730px) {
    grid-template-columns: repeat(8, 1fr);
  }

  @media (max-width: 1300px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 850px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const CheckboxItem = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.4;

  input[type="checkbox"] {
    flex-shrink: 0;
    margin-top: 2px;
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: white;
    position: relative;
    cursor: pointer;
    transition: 0.2s;
  }

  input[type="checkbox"]:checked {
    background-color: #104467;
    border-color: #104467;
  }

  input[type="checkbox"]:checked::after {
    content: "✔";
    position: absolute;
    top: -3px;
    left: 1px;
    color: white;
    font-size: 14px;
  }
`;

export const CheckboxGridOp = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  width: 100%;
  align-items: center;
`;

export const CheckboxItemOp = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.4;

  input[type="checkbox"] {
    all: unset;
    flex-shrink: 0;
    box-sizing: border-box;
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: white;
    position: relative;
    cursor: pointer;
    transition: 0.2s;
  }

  input[type="checkbox"]:checked {
    background-color: #104467;
    border-color: #104467;
  }

  input[type="checkbox"]:checked::after {
    content: "✔";
    position: absolute;
    top: -3px;
    left: 1px;
    color: white;
    font-size: 14px;
  }
`;

export const CheckboxGridRe = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  align-items: center;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
